module.exports = __webpack_public_path__ + "static/media/BS.9de1025d.jpg";